module.exports = __webpack_public_path__ + "media/images/novum-logo-animated-short-fcd754996e71e6e93b79dfcf7c0097ec.svg";